import Toast from "react-bootstrap/Toast";
import { ImSpinner2 } from "react-icons/im";

export type ToastType = "success" | "error" | "warning" | "processing";

export type ToastInfo = {
  id: string;
  show: boolean;
  type: ToastType;
  title: string;
  message: string;
};

type SubmissionToastProps = {
  toast: ToastInfo;
  onClose: (id: string) => void;
  onClick?: (id: string) => void;
};

const TOAST_CLASSES: Record<
  ToastType,
  {
    card: string;
    inner: string;
    strip: string;
    main: string;
    icon: string;
    iconClass: string;
    text: string;
    title: string;
    message: string;
  }
> = {
  success: {
    card: "toastSuccessCard",
    inner: "toastSuccessInner",
    strip: "toastSuccessStrip",
    main: "toastSuccessMain",
    icon: "toastSuccessIcon",
    iconClass: "bi bi-check-circle-fill",
    text: "toastSuccessText",
    title: "toastSuccessTitle",
    message: "toastSuccessMessage",
  },
  error: {
    card: "toastErrorCard",
    inner: "toastErrorInner",
    strip: "toastErrorStrip",
    main: "toastErrorMain",
    icon: "toastErrorIcon",
    iconClass: "bi bi-x-circle-fill",
    text: "toastErrorText",
    title: "toastErrorTitle",
    message: "toastErrorMessage",
  },
  warning: {
    card: "toastWarningCard",
    inner: "toastWarningInner",
    strip: "toastWarningStrip",
    main: "toastWarningMain",
    icon: "toastWarningIcon",
    iconClass: "bi bi-exclamation-triangle-fill",
    text: "toastWarningText",
    title: "toastWarningTitle",
    message: "toastWarningMessage",
  },
  processing: {
    card: "toastProcessingCard",
    inner: "toastProcessingInner",
    strip: "toastProcessingStrip",
    main: "toastProcessingMain",
    icon: "toastProcessingIcon",
    iconClass: "",
    text: "toastProcessingText",
    title: "toastProcessingTitle",
    message: "toastProcessingMessage",
  },
};

const TOAST_DELAYS: Record<ToastType, number | undefined> = {
  success: 6000,
  error: 8000,
  warning: 10000,
  processing: undefined,
};

export function SubmissionToast({
  toast,
  onClose,
  onClick,
}: SubmissionToastProps) {
  const classes = TOAST_CLASSES[toast.type];
  const isClickable = !!onClick;
  const isProcessing = toast.type === "processing";
  const delay = TOAST_DELAYS[toast.type];

  return (
    <Toast
      show={toast.show}
      onClose={() => onClose(toast.id)}
      delay={delay}
      autohide={!isProcessing}
      className={classes.card}
      style={isClickable ? { cursor: "pointer" } : undefined}
      onClick={isClickable ? () => onClick(toast.id) : undefined}
    >
      <div className={classes.inner}>
        <div className={classes.strip} />

        <div className={classes.main}>
          <div className={classes.icon} style={{ alignSelf: "flex-start" }}>
            {isProcessing ? (
              <ImSpinner2 className="toastSpinAnimation" />
            ) : (
              <i className={classes.iconClass} />
            )}
          </div>

          <div className={classes.text}>
            <div className={classes.title}>{toast.title}</div>
            <div className={classes.message}>{toast.message}</div>
          </div>

          <button
            type="button"
            className="btn-close ms-auto"
            aria-label="Close"
            style={{ alignSelf: "flex-start" }}
            onClick={(e) => {
              e.stopPropagation();
              onClose(toast.id);
            }}
          />
        </div>
      </div>
    </Toast>
  );
}